import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { fakeTableList, schema, stepper } from "./parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  CorpTypeList2,
  formClassCorp,
  FormKbn,
  Prefectures,
} from "../../assets/data/Constants";
import "./_style.scss";
import { httpAPI_CON009, httpAPI_CON016 } from "./api/request";
import { IAPI_CON009_Response } from "../../type/apiType";
import { FormList } from "../../type/apiType/IAPI_CON016";
import { ReissueApplyInput } from "./components/components";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";
import { changeZipcodeFormat } from "../../utils/useTools";

/**
 * SCRC040002 契約者基本情報　更新
 * このコンポーネントは、TkInfoManual、TkFakeTable、TkMessageDialogをレンダリングします。
 * @return SCRC040002 契約者基本情報　更新
 */
const SCRC040002 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [inputData, setInputData] = useState<any>({});
  const [openHoujin, setOpenHoujin] = useState(false);
  const [openKiko, setOpenKiko] = useState(false);
  const [resData, setResData] = useState<IAPI_CON009_Response>({});
  const [reissueValue, setReissueValue] = useState<any>({});
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [status, setStatus] = useState<any>("00");

  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const applyId = location.state?.applyId;

  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);
  const handleInit = async () => {
    try {
      // 契約者氏名等変更届・共済契約証書再交付申出参照
      const res = await httpAPI_CON009({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        applyId: applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;
        setStatus(res?.latestApplyStatus);
        const tobeDownload =
          res.latestApplyStatus !== "00" &&
          res.latestApplyStatus !== "16" &&
          res.latestApplyStatus !== null;
        resArr.find(
          (item) => item.keyword === "nameChangeDate"
        )!.setDefaultValue = res.nameChangeDate;
        resArr.find((item) => item.keyword === "newType")!.setDefaultValue =
          res.aBusinessOwnerClass;
        resArr.find((item) => item.keyword === "oldType")!.text = TkGetCode(
          CorpTypeList2,
          res.bBusinessOwnerClass
        );
        resArr.find((item) => item.keyword === "newNameKana")!.setDefaultValue =
          res.aCorpNameKana;
        resArr.find((item) => item.keyword === "newName")!.setDefaultValue =
          res.aCorpName;
        resArr.find((item) => item.keyword === "oldName")!.text = res.bCorpName;
        resArr.find(
          (item) => item.keyword === "directorTitle"
        )!.setDefaultValue = res.directorTitle;
        resArr.find(
          (item) => item.keyword === "directorName"
        )!.setDefaultValue = res.directorName;
        const fileData = res.formList?.find(
          (item) => item.formClass === formClassCorp["履歴事項全部証明書（写）"]
        );

        let historyCertificate = resArr.find(
          (item) => item.keyword === "historyCertificate"
        )!;
        if (tobeDownload) {
          if (fileData && fileData.fileBase64) {
            historyCertificate.type = "downloadLink";
            historyCertificate.downloadBase64 = true;
            historyCertificate.dataname = fileData.fileName;
            historyCertificate.base64filedata = fileData.fileBase64;
          }
        } else {
          historyCertificate.type = "fileUpload";
          if (fileData && fileData.fileBase64) {
            historyCertificate.setDefaultValue = [
              { formName: fileData.fileName, fileBase64: fileData.fileBase64 },
            ];
          }
        }

        resArr.find(
          (item) => item.keyword === "locationChangeDate"
        )!.setDefaultValue = res.addressChangeDate;
        let postcode = resArr.find((item) => item.keyword === "zipcode")!;
        postcode.getPostalCodeValue = (value: any) => {
          const data = value.value;

          let resObj = {
            prefectures: data.address1,
            city: `${data.address2}${data.address3}`,
            address: "",
          };

          resArr.find((item) => item.keyword === "newLocation")!.valueObject =
            resObj;

          setState({
            ...state,
            errorMsgId: "",
          });
        };

        postcode.getPostalCodeError = (value: any) => {
          setState({
            ...state,
            errorMsgId: value,
          });
        };
        postcode.setDefaultValue = res.aZipcode;
        let aPrefectureName = "";
        res.aPrefectureName &&
          (aPrefectureName = TkGetCode(Prefectures, res.aPrefectureName));
        let aCity = "";
        res.aCity && (aCity = res.aCity);
        let aAddressOthers = "";
        res.aAddressOthers && (aAddressOthers = res.aAddressOthers);
        resArr.find((item) => item.keyword === "newLocation")!.valueObject = {
          prefectures: aPrefectureName,
          city: aCity,
          address: aAddressOthers,
        };
        resArr.find((item) => item.keyword === "oldLocation")!.text =
          "〒" +
          (changeZipcodeFormat(res.bZipcode) ?? "") +
          "　" +
          TkGetCode(Prefectures, res.bPrefectureName ?? "") +
          (res.bCity ?? "") +
          (res.bAddressOthers ?? "");
        resArr.find((item) => item.keyword === "againReissue")!.node = (
          <ReissueApplyInput onChange={setReissueValue} res={res} />
        );
        setStatecorpInfoList([...resArr]);
        setState({ ...state, errorMsgId: "" });
        setResData(res);

        if (tobeDownload) {
          setShowSubmitButton(false);
          for (let i in res) {
            let targetObj = resArr.find((item) => item.keyword === i)!;
            targetObj && (targetObj.disabled = true);
          }
          resArr.find((item) => item.keyword === "newType")!.disabled = true;
          resArr.find((item) => item.keyword === "newNameKana")!.disabled =
            true;
          resArr.find((item) => item.keyword === "newName")!.disabled = true;
          resArr.find(
            (item) => item.keyword === "historyCertificate"
          )!.disabled = true;
          resArr.find(
            (item) => item.keyword === "locationChangeDate"
          )!.disabled = true;
          resArr.find((item) => item.keyword === "zipcode")!.disabled = true;
          resArr.find((item) => item.keyword === "newLocation")!.disabled =
            true;
          resArr.find((item) => item.keyword === "againReissue")!.node = (
            <ReissueApplyInput
              onChange={setReissueValue}
              res={res}
              disabled={true}
            />
          );
        }
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitEvent = (value: any) => {
    setInputData(value);
    if (isKiko) {
      setOpenKiko(true);
    } else {
      setOpenHoujin(true);
    }
  };

  const makeFormListObj = (): FormList[] => {
    let data = inputData.historyCertificate;
    let fileObj: FormList[] = [];

    if (data?.length) {
      fileObj = [
        {
          serialNo: 1,
          formKbn: FormKbn["法人書類"],
          formClass: formClassCorp["履歴事項全部証明書（写）"],
          staffNo: "",
          facilityNo: "",
          fileName: data[0].formName,
          fileBase64: data[0].fileBase64,
        },
      ];
    }

    return fileObj;
  };

  //業務チェック
  const handleCheckValidate = () => {
    if (!inputData?.nameChangeDate) {
      if (!!inputData?.newNameKana || !!inputData?.newName) {
        //入出力項目.契約者名称の変更年月日＝null かつ（入出力項目.（新）契約者名称（ｶﾅ）≠null または 入出力項目.（新）契約者名称≠null）の場合(TKMSG_SCR0102E)
        return "TKMSG_SCR0102E";
      }
      if (
        !inputData?.locationChangeDate &&
        !inputData?.directorTitle &&
        !inputData?.directorName &&
        (!reissueValue?.reissueApplyFlg ||
          reissueValue?.reissueApplyFlg === "0")
      ) {
        //入出力項目.契約者名称の変更年月日＝null かつ入出力項目.主たる事務所の所在地の変更年月日＝null かつ入出力項目.代表者職名＝null かつ入出力項目.代表者氏名＝null かつ（入出力項目.再交付の理由（共済契約証書再交付申出）＝null または 　入出力項目.再交付の理由（共済契約証書再交付申出）＝""0""(無)）(TKMSG_SCR0107E)        return "TKMSG_SCR0107E";
        return "TKMSG_SCR0107E";
      }
    }
    if (!!inputData?.nameChangeDate) {
      if (!inputData?.newNameKana && !inputData?.newName) {
        //入出力項目.契約者名称の変更年月日≠null かつ（入出力項目.（新）契約者名称（ｶﾅ）＝null かつ 入出力項目.（新）契約者名称＝null）の場合(TKMSG_SCR0103E)
        return "TKMSG_SCR0103E";
      }
      if (
        inputData?.historyCertificate === null ||
        inputData?.historyCertificate?.length === 0
      ) {
        // 入出力項目.契約者名称の変更年月日≠null かつ入出力項目.履歴事項全部証明書（写）＝null の場合エラーとする。(TKMSG_SCR0104E)
        return "TKMSG_SCR0104E";
      }
    }

    if (!inputData?.locationChangeDate) {
      //入出力項目.主たる事務所の所在地の変更年月日＝null かつ（入出力項目.（新）郵便番号≠null または,入出力項目.（新）主たる事務所の所在地（都道府県）≠null または,入出力項目.（新）主たる事務所の所在地（市区町村）≠null または,入出力項目.（新）主たる事務所の所在地（その他）≠null）(TKMSG_SCR0105E)
      if (
        !!inputData?.zipcode ||
        !!inputData.newLocation.prefectures ||
        !!inputData.newLocation.city ||
        !!inputData.newLocation.city
      ) {
        return "TKMSG_SCR0105E";
      }
    } else {
      //入出力項目.主たる事務所の所在地の変更年月日≠null かつ入出力項目.（新）郵便番号＝null かつ入出力項目.（新）主たる事務所の所在地（都道府県）＝null かつ入出力項目.（新）主たる事務所の所在地（市区町村）＝null かつ 入出力項目.（新）主たる事務所の所在地（その他）＝null(TKMSG_SCR0106E)
      if (
        !inputData?.zipcode &&
        !inputData.newLocation.prefectures &&
        !inputData.newLocation.city &&
        !inputData.newLocation.city
      ) {
        return "TKMSG_SCR0106E";
      }
    }
  };

  const handleOk = async (date?: any) => {
    //業務チェック
    const ValidationMsg = handleCheckValidate();
    if (!!ValidationMsg) {
      setState({
        ...state,
        errorMsgId: ValidationMsg,
      });
      isKiko ? setOpenKiko(false) : setOpenHoujin(false);
      return;
    }

    // 契約者氏名等変更届・共済契約証書再交付申出更新API実行
    try {
      const res = await httpAPI_CON016({
        applyId: resData.applyId,
        contractorNo,
        contractorChangeFlg: resData.contractorChangeFlg,
        facilityChangeFlg: resData.facilityChangeFlg,
        ...reissueValue,
        nameChangeDate: inputData.nameChangeDate,
        aBusinessOwnerClass: inputData.newType,
        bBusinessOwnerClass: resData.bBusinessOwnerClass,
        aCorpName: inputData.newName,
        bCorpName: resData.bCorpName,
        aCorpNameKana: inputData.newNameKana,
        bCorpNameKana: resData.bCorpNameKana,
        directorTitle: inputData.directorTitle,
        directorName: inputData.directorName,
        formList: makeFormListObj(),
        addressChangeDate: inputData.locationChangeDate,
        aZipcode: inputData.zipcode,
        aPrefectureCd:
          Prefectures[
            inputData.newLocation.prefectures as keyof typeof Prefectures
          ],
        aCity: inputData.newLocation.city,
        aAddressOthers: inputData.newLocation.address,
        bZipcode: resData.bZipcode,
        bPrefectureCd: resData.bPrefectureName,
        bCity: resData.bCity,
        bAddressOthers: resData.bAddressOthers,
        receptionDate: date,
        screenId: "SCRC040002",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC040002PageForTest" className="tkSCRC040002">
      <TkStepper
        steps={stepper}
        activeStep={status === "00" || status === "16" ? 0 : 1}
      />

      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}

      {/* TkFakeTableを表示 */}
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText={isKiko ? "申請" : "機構へ提出する"}
        onCheckAndSubmit={submitEvent}
        showButton={showSubmitButton}
      />

      <TkMessageDialog
        open={openHoujin}
        onOky={() => handleOk(null)}
        onCancel={() => setOpenHoujin(false)}
        title="確認（機構へ提出する）"
        contextText="機構へ提出を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />

      <TkDateDialog
        open={openKiko}
        onOky={handleOk}
        onCancel={() => setOpenKiko(false)}
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        title="確認（申請）"
        contextText="申請を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC040002;
